// extracted by extract-css-chunks-webpack-plugin
module.exports = {"root":"bubble-count__root__sIVEq"};